import { React, useState } from 'react';
import {
  AdjustmentsHorizontalIcon,
  ArrowsUpDownIcon
} from '@heroicons/react/20/solid';
import VenueList from '../../Components/Venue/List';
import { ReactSVG } from 'react-svg';
import { capitalize } from '../../Utils';


const AboutUs = () => {


  const [kelebihan] = useState([
    {
      image: "/img-why-fityuk-1.svg",
      title: "Reservasi Lapang Mudah",
      description: "Anda tak perlu menginstall aplikasi, cukup menggunakan browser lalu mengisi nama, nomor telepon, dan email. Anda sudah dapat melakukan reservasi lapang."
    },
    {
      image: "/img-why-fityuk-2.svg",
      title: "Berbagai Macam Pilihan Jenis Olahraga",
      description: "Berbagai olahraga populer yang banyak digemari saat ini seperti sepakbola, mini soccer, futsal, badminton, tennis, padel)"
    },
    {
      image: "/img-why-fityuk-3.svg",
      title: "Berbagai Macam Pilihan Metode Pembayaran",
      description: "Fityuk menyediakan Virtual Account dari bank-bank umum, serta E-Money untuk membayar reservasi lapang anda."
    },
    {
      image: "/img-why-fityuk-4.svg",
      title: "Layanan Support",
      description: "Jika reservasi lapang anda mengalami kendala, silahkan hubungi Customer Service kami segera."
    }
  ]);

  return (
    <div className='flex flex-col'>
    <div className='flex justify-center items-center bg-[#d43a3a]/80 rounded-full mx-auto px-6 py-4 lg:px-10 lg:py-4'>
      <span className='text-center text-white font-bold text-[18px] lg:text-[22px]'>
        Tentang Kami
      </span>
    </div>

      <div className='rounded-2xl bg-[#fff] p-8 mt-8 lg:p-12'>

<div className='flex mt-4 flex-col space-y-8 lg:flex-row lg:space-x-12 lg:space-y-0'>

  <img className='w-full lg:w-1/3 aspect-[280/171] object-cover rounded rounded-xl' src='/img-fityuk-field.webp' />

  <div className=' flex flex-col'>
    <span className='text-[27px] font-extrabold'>
      Apa itu FitYuk?
    </span>
    <span className="mt-4 text-[18px] ">
    Fityuk merupakan sebuah Platform untuk memfasilitasi anda yang gemar berolahraga dan ingin memesan lapangan secara cepat, dan praktis, langsung melalui Gadget anda tanpa harus menginstall Aplikasi. Fityuk mempertemukan pengguna dan vendor sebagai penyedia lapangan olahraga. 
<br /><br />
Fityuk bekerjasama dengan Vendor-vendor yang telah melalui tahap verifikasi secara cermat dan sesuai dengan standar lapangan olahraga yang layak. Sehingga pengguna Fityuk (Penyewa Lapang) tidak perlu khawatir akan kelayakan lapangan yang disewa.
    </span>
  </div>

</div>

<div className='flex mt-16 flex-col space-y-8 lg:flex-row lg:space-y-0'>

<img className='w-full lg:w-1/2 lg:hidden inline-block' src='/img-pengguna-fityuk.webp' />
  <div className=' flex flex-col'>
    <span className='text-[27px] font-extrabold'>
    Pengguna Fityuk
    </span>
    <span className="mt-4 text-[18px] ">
    Adalah mereka para penggiat olahraga baik perorangan atau kelompok yang mencari lapangan untuk menyalurkan aktifitas olahraga mereka seperti Sepakbola, Futsal, Badminton, Padel, Basket, dan lainnya. 
<br />
<br />
Mereka biasanya menyewa lapangan dengan cara datang langsung ke lokasi, atau booking manual melalui admin lapangan via telepon. Kini dengan Fityuk, mereka tak perlu repot dan khawatir tidak kebagian jadwal karena alokasi jadwal lapangan yang Fityuk sediakan bersifat real time.
    </span>
  </div>

  <img className='w-full lg:w-1/2  lg:ml-12 hidden lg:inline-block' src='/img-pengguna-fityuk.webp' />


</div>

<div className='flex mt-16 flex-col space-y-8 lg:flex-row lg:space-x-12 lg:space-y-0'>

  <img className='w-full lg:w-1/2' src='/img-vendor-fityuk.webp' />

  <div className=' flex flex-col'>
    <span className='text-[27px] font-extrabold'>
    Vendor Fityuk
    </span>
    <span className="mt-4 text-[18px] ">
    Adalah partner yang bekerjasama dengan Fityuk untuk mengelola jadwal booking lapangan olahraga mereka. Vendor dapat menambahkan lapang, mengelola, dan memantau setiap aktifitas lapangan yang mereka miliki. 
<br />
<br />
Vendor juga dapat membuat Add-On sebagai pelengkap seperti Air Minum, Piala, Makanan Ringan, Jersey, dan lain-lain untuk ditawarkan kepada Pengguna Fityuk. Juga ketika Vendor membuat paket dapat disertakan dengan layanan fotografer, videographer dan wasit.
    </span>
  </div>

</div>

        <div className=' flex flex-col mt-12'>
          <span className='text-[27px] font-extrabold'>
          Cara Memesan Lapang
          </span>

          <div className="mt-8 grid gap-4 sm:grid-cols-1 lg:grid-cols-2">
            {
              kelebihan.map((item, index) => (
                <div key={index} className="flex flex-row space-x-6 items-start">
                  <img src={item.image} alt="Item" className="w-[93px]" />
                  <div className="flex flex-col">
                    <span className='text-[19px] font-extrabold'>{item.title}</span>
                    <span className="mt-4 text-[15px]">{item.description}</span>
                  </div>
                </div>
              ))
            }
          </div>
        </div>
      </div>
    </div>
  )
}

export default AboutUs;